import React, { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import {
  CheckboxWrapper,
  CustomCheckbox,
} from "../Utils/CustomClasses";
import styled from "styled-components";

const CustomCheckboxWrapper = styled(CheckboxWrapper)`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0;

  span {
    flex: 1;
    min-width: 0;
  }
`;

// Styled checkbox with proper alignment
const CustomCheckboxForm = styled(CustomCheckbox)`
  border: 2px solid rgba(17, 17, 19, 0.39);
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

`;

const ExpandableSections = ({ filters, onFiltersChange }) => {
  const [activeSection, setActiveSection] = useState(null);
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
    onFiltersChange(filters);
  }, [filters]);

  const toggleSection = (title) => {
    setActiveSection((prev) => (prev === title ? null : title));
  };

  const handleCheckboxChange = (sectionId, optionId) => {
    const updatedFilters = localFilters.map((section) => {
      if (section.id === sectionId) {
        const option21Selected = section.options.find((opt) => opt.id === 21)?.selected;

        return {
          ...section,
          options: section.options.map((option) => {
            if (optionId === 21) {
              // Toggle 21 and sync 22 with its state
              if (option.id === 21) return { ...option, selected: !option.selected };
              if (option.id === 22) return { ...option, selected: !option21Selected };
            }

            if (optionId === 22) {
              if (option.id === 22) return { ...option, selected: !option.selected };
            }

            return option.id === optionId
              ? { ...option, selected: !option.selected }
              : option;
          }),
        };
      }
      return section;
    });

    setLocalFilters(updatedFilters);
    onFiltersChange(updatedFilters);
  };

  const renderDynamicCheckboxes = (sections) => {
    return sections.map((section) => {
      const yesOption = section.options.find((opt) =>
        opt.name.toLowerCase().includes("yes")
      );
      if (!yesOption) return null;

      return (
        <CustomCheckboxWrapper
          key={section.id}
          style={{ cursor: "pointer" }}
          onClick={() => handleCheckboxChange(section.id, yesOption.id)}
        >
          <CustomCheckboxForm>
            {yesOption.selected && <img src="/images/check-icon.svg" alt="check" />}
          </CustomCheckboxForm>
          <span style={{ fontSize: "14px", lineHeight: "1.2" }}>
            {section.name}
          </span>
        </CustomCheckboxWrapper>
      );
    });
  };

  const renderStandardOptions = (section) => {
    return section.options.map((option) => (
      <CustomCheckboxWrapper
        key={option.id}
        style={{ cursor: "pointer" }}
        onClick={() => handleCheckboxChange(section.id, option.id)}
      >
        <CustomCheckboxForm>
          {option.selected && <img src="/images/check-icon.svg" alt="check" />}
        </CustomCheckboxForm>
        <span style={{ fontSize: "14px", lineHeight: "1.2" }}>
          {option.name}
        </span>
      </CustomCheckboxWrapper>
    ));
  };

  return (
    <div>
            {/* Amenities Available */}
      <div className="card mb-4 border-0 shadow-sm">
        <div
          className="card-header d-flex justify-content-between align-items-center py-3 px-4 bg-light"
          onClick={() => toggleSection("Amenities Available")}
          style={{ cursor: "pointer" }}
        >
         <h5 className="mb-0 text-dark text-center w-100">Amenities Available</h5>
          <span className="d-flex align-items-center" style={{ paddingRight: "10px" }}>
            {activeSection === "Amenities Available" ? (
              <FaChevronUp size={18} className="text-muted" />
            ) : (
              <FaChevronDown size={18} className="text-muted" />
            )}
          </span>
        </div>
        <div
          className={`collapse ${
            activeSection === "Amenities Available" ? "show" : ""
          }`}
        >
          <div className="card-body p-3 bg-white">
            {localFilters
              .filter((section) => section.id === 2)
              .map((section) => renderStandardOptions(section))}
          </div>
        </div>
      </div>
      {/* Access and Rules */}
      <div className="card mb-4 border-0 shadow-sm">
        <div
          className="card-header d-flex justify-content-between align-items-center py-3 px-4 bg-light"
          onClick={() => toggleSection("Access and Rules")}
          style={{ cursor: "pointer" }}
        >
          <h5 className="mb-0 text-dark text-center w-100">Access and Rules</h5>
          <span className="d-flex align-items-center" style={{ paddingRight: "10px" }}>
            {activeSection === "Access and Rules" ? (
              <FaChevronUp size={18} className="text-muted" />
            ) : (
              <FaChevronDown size={18} className="text-muted" />
            )}
          </span>
        </div>
        <div
          className={`collapse ${
            activeSection === "Access and Rules" ? "show" : ""
          }`}
        >
          <div className="card-body p-3 bg-white">
            {renderDynamicCheckboxes(
              localFilters.filter((section) => [5, 6, 7].includes(section.id))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpandableSections;
